<template>
  <div class="secao-vazia">
    <b-icon class="icone-aviso mb-2" icon="exclamation-triangle" font-scale="7.5"></b-icon>
    <p>Nenhum chamado encontrado!</p>
  </div>
</template>

<script>
export default {
  name: 'SecaoVazia'
};
</script>

<style scoped>
.secao-vazia {
  text-align: center;
}

.icone-aviso {
  margin-top: 50px;
}
</style>
